import { Link } from "react-router-dom";
import { topics } from "@/mocks/posts";

export default function TopicCloud() {
  return (
    <div className="rounded-lg border border-background-200/70 bg-secondary-50 p-4 md:p-5">
      <h3 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950 mb-3">
        <i className="ri-hashtag text-secondary-600" aria-hidden="true"></i>
        热门话题
      </h3>
      <div className="flex flex-wrap gap-2">
        {topics.map((topic, index) => (
          <Link
            key={topic}
            to={`/search?q=${encodeURIComponent(topic)}`}
            className={`rounded-full px-3 py-1.5 text-xs whitespace-nowrap transition-colors ${
              index % 3 === 0
                ? "bg-secondary-500 text-background-50 hover:bg-secondary-600"
                : "bg-background-50 text-foreground-700 border border-background-200/70 hover:border-secondary-400 hover:text-secondary-700"
            }`}
          >
            #{topic}
          </Link>
        ))}
      </div>
    </div>
  );
}